module.exports = __webpack_public_path__ + "img/pic.2e57b48c.png";